// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".14816ebce6baa131fc1a840513304ab5ef0e8680.chunk.bundle.js";
};